// src/admin/AdminApp.jsx
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import Contacts from './pages/Contacts';
import Visitors from './pages/Visitors';
import Volunteers from './pages/Volunteers';
import Members from './pages/Members';
import OpenHouse from './pages/OpenHouse';
import News from './pages/News';
import Facebook from './pages/Facebook';
import Events from './pages/Events';

// NEW pages
import MeetingMinutes from './pages/MeetingMinutes';
import FinancialReports from './pages/FinancialReports';

export default function AdminApp() {
    return (
        <Routes>
            <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="/admin/visitors" replace />} />
                <Route path="contacts" element={<Contacts />} />
                <Route path="visitors" element={<Visitors />} />
                <Route path="volunteers" element={<Volunteers />} />
                <Route path="members" element={<Members />} />
                <Route path="meeting-minutes" element={<MeetingMinutes />} />
                <Route path="financial-reports" element={<FinancialReports />} />
                <Route path="events" element={<Events />} />
                <Route path="news" element={<News />} />
                <Route path="open-house" element={<OpenHouse />} />
                <Route path="facebook" element={<Facebook />} />
            </Route>
        </Routes>
    );
}
